export default __webpack_public_path__ + "static/mentor-8376bd02d84121213d8227922284adf9.jpeg";